/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Securitytype1Inputs */

const en_common_securitytype1 = /** @type {(inputs: Common_Securitytype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security Type`)
};

/**
* | output |
* | --- |
* | "Security Type" |
*
* @param {Common_Securitytype1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_securitytype1 = /** @type {((inputs?: Common_Securitytype1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Securitytype1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_securitytype1(inputs)
});
export { common_securitytype1 as "common_securityType" }